import queryString from 'query-string';
import { GOOGLE_MAP_SEARCH_URL } from '../constants/index';

export const composeGoogleMapUrl = query =>
  `${GOOGLE_MAP_SEARCH_URL}?${queryString.stringify({ api: 1, query })}`;
